export const findParentRecord = (arrayOfRecords: List[], recordId: number) =>
	arrayOfRecords.find((list: List) => (list.id ? list.id == recordId : false))
